module.exports = __webpack_public_path__ + "static/media/6.3ca591e3.png";